import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-task-detail-page',
  templateUrl: './task-detail-page.component.html',
  styleUrls: ['./task-detail-page.component.css']
})
export class TaskDetailPageComponent {
  requestid = 0;

  constructor(private readonly router: Router,private readonly route: ActivatedRoute,) {
    this.route.params.subscribe(params => {
      this.requestid = params['id'];
      console.log(this.requestid);
    });
  }

  ngOnInit() {
    
  }
}
